module.exports = __webpack_public_path__ + "static/img/undealuser.4b66595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/undealuser.png
// module id = 1277
// module chunks = 0